module.exports = __webpack_public_path__ + "media/images/logo-51486f9e167580b1e501f517d3f1aa75.svg";